import { v4 as uuid } from 'uuid';
import env from '@y2/environments';
import { analytics } from '@y2/google-tag-manager/v2/synchronized';

export const getBestieNavigationLink = () => {
  const trackingId = uuid();
  const baseUrl = env.routes.bestie;
  const url = new URL(baseUrl);

  url.searchParams.set('utm_campaign', 'general_navigation');
  url.searchParams.set('utm_source', 'yad2');
  url.searchParams.set('utm_medium', 'collab');
  url.searchParams.set('utm_content', trackingId);

  return { url: url.toString(), trackingId };
};

export const pushBestieNavigationEvent = (trackingId: string) => {
  analytics.pushEvent({
    EventName: 'navigation',
    EventDetail: 'header',
    EventText: 'השוואת_ביטוח_רכב',
    EventGroup: 'browsing_interactions',
    // eslint-disable-next-line camelcase
    tracking_id: trackingId,
  });
};
